

 export const initialFormData = {
      OrganismePrincipal: false,
      QuiformeEstlaSource: false, // true si les données viennent de Quiforme, false si elles sont saisies manuellement

      Siret: '',//ok fail
      Uai: '',//ok fail
      NumDe: '',//ok fail
      DateDerniereDeclaration: '',//ok fail

      Adresse1: '',//ok fail
      Adresse2: '',//ok fail            pas retourné par Quiforme mais utile pour fail
      VilleId: 0,//ok fail               utile pour fail
      Codepostal: '',
      Commune: '',
      
      RaisonSociale: '',//SUREMENT CELUI QUI EST LE PLUIS IMPORTANT ok fail
      Cat_juridique: '',
      Libelle_cat_juridique: '',
      Sigle: '',//ok fail               utile pour fail

      Denomination: '',
      Enseigne: '',
      Code_ape: '',
      Date_creation: '',//ok fail

      Email: '',//ok fail
      OrgTelPortable: '',//ok fail
      OrgTelFixe: '',//ok fail
      SiteWeb: '',//ok fail
      
      NomReferent: '', // quelle utilité ????
      PrenomReferent: '',// quelle utilité ????

      Message: '',
      EstCfa: false, //ok fail
      
      ResponsableNom: '',//ok fail
      ResponsablePrenom: '',//ok fail
      ResponsableMail: '',//ok fail
      ResponsableMailConfirm: '',//ok fail
      ResponsableTelFixe: '',//ok fail
      ResponsableTelPortable: '',//ok fail
      
      QualiopiActionFormation: null,
      QualiopiBilanCompetence: null,
      QualiopiVae: null,
      QualiopiApprentissage: null, 

      
      LieuDenomination: '',
      LieuAdresse1: '',
      LieuAdresse2: '',
      LieuVilleId: 0,
      LieuVilleLib: '',
      LieuMail: '', 
      LieuMailConfirm: '',
      LieuTelFixe: '',
      LieuTelPortable: '',
      LieuSiteWeb: '',

      EstEnPaca: 1, // 1 si département PACA, 0 sinon
  };